import { Build, Component, h, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'mama-scroll-to-top',
  styleUrl: './mama-scroll-to-top.scss',
})
export class ScrollToTop {
  @State() active = false;
  private observer?: IntersectionObserver;

  async componentWillLoad() {
    if (navigator.userAgent.match(/VisualRegressionTestingBot/i) || !Build.isBrowser) {
      return;
    }
    this.observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        this.active = !entries[0].isIntersecting;
      },
      { rootMargin: '300px 10px 0px 10px' },
    );
    this.observer.observe(document.querySelector('#content'));
  }

  @Listen('click')
  clickHandler() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  render() {
    return (
      <Host role="button" title="Scroll to top" class={{ active: this.active }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24" height="24">
          <path d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z" />
        </svg>
      </Host>
    );
  }
}
